import { IGetHMCATableQueryParams } from 'app/services/api/hmca/consequencearea'

export const skipQueryConditions = (
  queryParamsObject: IGetHMCATableQueryParams,
  baseCase: boolean
) => {
  const { fromDate, toDate } = queryParamsObject

  // simplify date comparison and dedupe
  const symmetricDates = new Set([fromDate || toDate, toDate])

  // filter the set
  symmetricDates.delete(undefined)
  symmetricDates.delete('')

  const datesArray = Array.from(symmetricDates.values())

  const [leftDate, rightDate] = datesArray

  const validateYear = (year: number) => year > 1899 && year < 2100

  // fromDate alone is fine
  if (leftDate) {
    // this should resolve to [year, month, day]
    const [fromYear] = leftDate.split('-').map(Number)

    if (rightDate) {
      const [toYear] = rightDate.split('-').map(Number)

      // don't query for years below 1900, above 2099, or incomplete entries like 0202 (2020s)
      if ([fromYear, toYear].every(validateYear)) {
        // ? what should be the case where toYear > fromYear

        return baseCase
      }

      // skip query if both dates are entered but invalid; (both dates need to be valid)
      return true
    }

    // if year a string, full date has been entered
    // let the user enter the correct date or clear it
    if (!validateYear(fromYear)) {
      return true
    }

    // defer to baseCase even if fromDate is valid (ex. cache restore scenario)
    return baseCase
  }

  // when dates are not supplied
  return baseCase
}
